<div class="bg-success text-white text-center p-1 text-md" >{{localization.messages.new_update_available | translate}}.
  
  <span class="text-white cursor-pointer underline font-semibold text-md" (click)="update()">{{localization.labels.update | translate }}</span></div>